<template>
  <div class="friends_container">
    <div class="friends_title font-title">合作伙伴</div>
    <div class="friends_box">
      <div class="friends_items">
        <div class="friends_items_inner">
          <img class="friends_item_img" v-for="(item, index) in iconList" :key="'a' + index" :src="item.image" />
          <img class="friends_item_img" v-for="(item, index) in iconList" :key="'b' + index" :src="item.image" />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      // iconList: [
      //   {
      //     image: require("@/assets/friendsIcon/1.jpg"),
      //   },
      //   {
      //     image: require("@/assets/friendsIcon/2.jpg"),
      //   },
      //   {
      //     image: require("@/assets/friendsIcon/3.jpg"),
      //   },
      //   {
      //     image: require("@/assets/friendsIcon/4.jpg"),
      //   },
      //   {
      //     image: require("@/assets/friendsIcon/5.jpg"),
      //   },
      //   {
      //     image: require("@/assets/friendsIcon/6.jpg"),
      //   },
      //   {
      //     image: require("@/assets/friendsIcon/7.jpg"),
      //   },
      //   {
      //     image: require("@/assets/friendsIcon/8.jpg"),
      //   },
      //   {
      //     image: require("@/assets/friendsIcon/9.jpg"),
      //   },
      //   {
      //     image: require("@/assets/friendsIcon/10.jpg"),
      //   },
      //   {
      //     image: require("@/assets/friendsIcon/11.jpg"),
      //   },
      //   {
      //     image: require("@/assets/friendsIcon/12.jpg"),
      //   },
      //   {
      //     image: require("@/assets/friendsIcon/13.jpg"),
      //   },
      //   {
      //     image: require("@/assets/friendsIcon/14.jpg"),
      //   },
      //   {
      //     image: require("@/assets/friendsIcon/15.jpg"),
      //   },
      //   {
      //     image: require("@/assets/friendsIcon/16.jpg"),
      //   },
      //   {
      //     image: require("@/assets/friendsIcon/17.jpg"),
      //   },
      //   {
      //     image: require("@/assets/friendsIcon/18.webp"),
      //   },
      //   {
      //     image: require("@/assets/friendsIcon/19.jpg"),
      //   },
      //   {
      //     image: require("@/assets/friendsIcon/20.jpg"),
      //   },
      //   {
      //     image: require("@/assets/friendsIcon/21.jpg"),
      //   },
      //   {
      //     image: require("@/assets/friendsIcon/22.jpg"),
      //   },
      //   {
      //     image: require("@/assets/friendsIcon/23.jpg"),
      //   },
      //   {
      //     image: require("@/assets/friendsIcon/24.jpg"),
      //   },
      //   {
      //     image: require("@/assets/friendsIcon/25.jpg"),
      //   },
      //   {
      //     image: require("@/assets/friendsIcon/26.jpg"),
      //   },
      //   {
      //     image: require("@/assets/friendsIcon/27.jpg"),
      //   },
      //   {
      //     image: require("@/assets/friendsIcon/28.jpg"),
      //   },
      //   {
      //     image: require("@/assets/friendsIcon/29.jpg"),
      //   },
      //   {
      //     image: require("@/assets/friendsIcon/30.jpg"),
      //   },
      //   {
      //     image: require("@/assets/friendsIcon/31.jpg"),
      //   },
      //   {
      //     image: require("@/assets/friendsIcon/32.jpg"),
      //   },
      //   {
      //     image: require("@/assets/friendsIcon/33.jpg"),
      //   },
      //   {
      //     image: require("@/assets/friendsIcon/34.jpg"),
      //   },
      //   {
      //     image: require("@/assets/friendsIcon/35.jpg"),
      //   },
      //   {
      //     image: require("@/assets/friendsIcon/36.jpg"),
      //   },
      // ],
      iconList: [
        {
          image: require("@/assets/friendsIcon/merged_output.png"),
        },
      ],
    };
  },
  mounted() {},
};
</script>

<style lang="scss" scoped>
@import "swiper/css/swiper.min.css";

.friends_container {
  width: 100vw;
  padding-bottom: 110px;
  // background-color: #f2f3ed;
  background-color: #fff;

  .friends_title {
    padding-top: 70px;
    width: 100%;
    padding-bottom: 20px;
    text-align: center;
  }

  .friends_box {
    overflow: hidden;
    width: 100%;
    position: relative;
    padding: 40px 0;

    .friends_items {
      width: 100%;
      white-space: nowrap;
      overflow: hidden;
      position: relative;

      .friends_items_inner {
        will-change: transform;
        animation: scroll 40s linear infinite;
        width: max-content; // 保证宽度是实际内容
      }

      .friends_item_img {
        height: 160px;
        margin: 0 40px;
        flex-shrink: 0;
      }
    }
  }

  @keyframes scroll {
    from {
      transform: translateX(0);
    }
    to {
      transform: translateX(-50%);
    }
  }

  .friends_items_inner {
    animation-play-state: running;
  }

  .friends_items:hover .friends_items_inner {
    animation-play-state: paused;
  }
}
</style>
